import React, { type ReactNode } from "react";
import type { SetterConfig, Stylesheet } from "entities/AppTheming";
import type {
  AnvilConfig,
  AutocompletionDefinitions,
  WidgetBaseConfiguration,
  WidgetDefaultProps,
} from "WidgetProvider/types";
import type { DerivedPropertiesMap } from "WidgetProvider/factory/types";
import type { WidgetProps, WidgetState } from "widgets/BaseWidget";
import BaseWidget from "widgets/BaseWidget";
import type { ContainerWidgetProps } from "widgets/ContainerWidget/widget";
import {
  anvilConfig,
  autocompleteConfig,
  defaultsConfig,
  metaConfig,
  methodsConfig,
  propertyPaneContent,
  propertyPaneStyle,
} from "./config";
import { AIChatWidget } from "./AIChatWidget";

export interface WDSAIChatWidgetProps
  extends ContainerWidgetProps<WidgetProps> {
  initialAssistantMessage: string;
  initialAssistantSuggestions: Array<{ label: string; value: string }>;
  assistantName: string;
  promptInputPlaceholder: string;
  chatHeightSize: "MEDIUM" | "LARGE" | "FIT_PAGE";
  queryRun: string;
}

class WDSAIChatWidget extends BaseWidget<WDSAIChatWidgetProps, WidgetState> {
  static type = "WDS_AI_CHAT_WIDGET";

  static getConfig(): WidgetBaseConfiguration {
    return metaConfig;
  }

  static getDefaults(): WidgetDefaultProps {
    return defaultsConfig;
  }

  static getPropertyPaneConfig() {
    return [];
  }
  static getPropertyPaneContentConfig() {
    return propertyPaneContent;
  }

  static getPropertyPaneStyleConfig() {
    return propertyPaneStyle;
  }

  static getMethods() {
    return methodsConfig;
  }

  static getAutocompleteDefinitions(): AutocompletionDefinitions {
    return autocompleteConfig;
  }

  static getSetterConfig(): SetterConfig | null {
    return {
      __setters: {
        setVisibility: {
          path: "isVisible",
          type: "boolean",
        },
      },
    };
  }

  static getDerivedPropertiesMap(): DerivedPropertiesMap {
    return {};
  }

  static getDefaultPropertiesMap(): Record<string, string> {
    return {};
  }

  static getMetaPropertiesMap(): Record<string, unknown> {
    return {};
  }

  static getAnvilConfig(): AnvilConfig | null {
    return anvilConfig;
  }

  static getStylesheetConfig(): Stylesheet {
    return {};
  }

  getWidgetView(): ReactNode {
    return (
      <AIChatWidget
        {...this.props}
        isWidgetSelected={this.props.isWidgetSelected || false}
      />
    );
  }
}

export default WDSAIChatWidget;
